var $a6e5541030242f67$exports = {};
$a6e5541030242f67$exports = {
    "loading": `Caricamento...`,
    "loadingMore": `Caricamento altri...`
};


export {$a6e5541030242f67$exports as default};
//# sourceMappingURL=it-IT.module.js.map
